import { Divider, type SxProps, Typography } from "@mui/material";
import Section from "@/components/Section";
import { useCampground } from "@/contexts/AppConfigContext";
import { formatCampgroundAddress } from "@/utils/address";
import BookingSearchDetails from "./BookingSearchDetails";

export default function BookingSummary({ sx }: { sx?: SxProps }) {
  const { data: campgroundData } = useCampground();

  return (
    <Section title={campgroundData.campground?.name || ""} sx={sx}>
      <Typography
        variant="body2"
        gutterBottom
        sx={{ whiteSpace: "pre-wrap", color: "text.secondary" }}
      >
        {formatCampgroundAddress(campgroundData.campground, campgroundData.countries)}
      </Typography>
      <Divider sx={{ my: 2 }} />
      <BookingSearchDetails />
    </Section>
  );
}
